import { useEffect, useState } from 'react';
import { Bell, Search } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { configApi } from '../../api/client';

const titles = {
  '/dashboard': 'Dashboard',
  '/triggers': 'Triggers',
  '/builds': 'Builds',
  '/services': 'Services',
  '/environments': 'Environments',
};

const ENV_BADGE = {
  dev:        'bg-blue-500/10 text-blue-400 border-blue-500/20',
  staging:    'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  production: 'bg-green-500/10 text-green-400 border-green-500/20',
};

export default function Header() {
  const { pathname } = useLocation();
  const title = Object.entries(titles).find(([path]) => pathname.startsWith(path))?.[1] || 'CI/CD Platform';
  const [env, setEnv] = useState(null);

  useEffect(() => {
    configApi.get().then(cfg => setEnv(cfg.env)).catch(() => {});
  }, []);

  return (
    <header className="h-14 shrink-0 border-b border-slate-200 flex items-center justify-between px-6 bg-surface-0/80 backdrop-blur-sm sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <h1 className="text-sm font-semibold text-slate-900">{title}</h1>
        {env && (
          <span className={`px-2 py-0.5 rounded-md text-[10px] font-semibold border uppercase tracking-wider ${ENV_BADGE[env] || ENV_BADGE.dev}`}>
            {env}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        {/* Search */}
        <button className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-slate-100 border border-slate-200 text-slate-400 text-sm hover:border-slate-300 hover:text-slate-900 transition-colors">
          <Search size={14} />
          <span className="text-xs">Search...</span>
          <kbd className="hidden sm:inline text-xs bg-slate-200 px-1.5 py-0.5 rounded text-slate-500">⌘K</kbd>
        </button>

        {/* Notifications */}
        <button className="relative w-8 h-8 rounded-lg hover:bg-slate-100 flex items-center justify-center text-slate-400 hover:text-slate-900 transition-colors">
          <Bell size={16} />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-accent-purple rounded-full" />
        </button>

        {/* Avatar */}
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent-purple to-accent-cyan flex items-center justify-center text-white text-xs font-bold cursor-pointer">
          NK
        </div>
      </div>
    </header>
  );
}
